import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const CreditreportsummaryListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/creditreportsummary/view/${data.report_id}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('creditreportsummary/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/creditreportsummary/edit/${data.report_id}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('creditreportsummary/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.report_id) },
			icon: "pi pi-trash",
			visible: () => auth.canView('creditreportsummary/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function ReportIdTemplate(data){
		if(data){
			return (
				<Link to={`/creditreportsummary/view/${data.report_id}`}> { data.report_id }</Link>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-creditreportsummary`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="creditreportsummary/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="CreditreportsummaryListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('creditReportSummary')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/creditreportsummary/add`}>
                            <Button label={$t('addNewCreditReportSummary')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="report_id" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="report_id" header={$t('reportId')} body={ReportIdTemplate} sortable={true} ></Column>
                                            <Column  field="fullname" header={$t('fullname')}  sortable={true} ></Column>
                                            <Column  field="firstname" header={$t('firstname')}  sortable={true} ></Column>
                                            <Column  field="middlename" header={$t('middlename')}  sortable={true} ></Column>
                                            <Column  field="lastname" header={$t('lastname')}  sortable={true} ></Column>
                                            <Column  field="addline1" header={$t('addline1')}  sortable={true} ></Column>
                                            <Column  field="voterid" header={$t('voterid')}  sortable={true} ></Column>
                                            <Column  field="nationalid" header={$t('nationalid')}  sortable={true} ></Column>
                                            <Column  field="noofactiveaccounts" header={$t('noofactiveaccounts')}  sortable={true} ></Column>
                                            <Column  field="numberofpastdueaccounts" header={$t('numberofpastdueaccounts')}  sortable={true} ></Column>
                                            <Column  field="totaloutstandingbalance" header={$t('totaloutstandingbalance')}  sortable={true} ></Column>
                                            <Column  field="totalinstallmentamount" header={$t('totalinstallmentamount')}  sortable={true} ></Column>
                                            <Column  field="mfnumberofopenaccounts" header={$t('mfnumberofopenaccounts')}  sortable={true} ></Column>
                                            <Column  field="mfnumberofpastdueaccounts" header={$t('mfnumberofpastdueaccounts')}  sortable={true} ></Column>
                                            <Column  field="mftotaloutstandingbalance" header={$t('mftotaloutstandingbalance')}  sortable={true} ></Column>
                                            <Column  field="mfrecentaccount" header={$t('mfrecentaccount')}  sortable={true} ></Column>
                                            <Column  field="mfinstallmentamount" header={$t('mfinstallmentamount')}  sortable={true} ></Column>
                                            <Column  field="mftotalpastdueamount" header={$t('mftotalpastdueamount')}  sortable={true} ></Column>
                                            <Column  field="userid" header={$t('userid')}  sortable={true} ></Column>
                                            <Column  field="creditscore" header={$t('creditscore')}  sortable={true} ></Column>
                                            <Column  field="total_utilization" header={$t('totalUtilization')}  sortable={true} ></Column>
                                            <Column  field="total_credit_exposure" header={$t('totalCreditExposure')}  sortable={true} ></Column>
                                            <Column  field="credit_card_utilization" header={$t('creditCardUtilization')}  sortable={true} ></Column>
                                            <Column  field="mrs" header={$t('mrs')}  sortable={true} ></Column>
                                            <Column  field="ers" header={$t('ers')}  sortable={true} ></Column>
                                            <Column  field="rdate" header={$t('rdate')}  sortable={true} ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
CreditreportsummaryListPage.defaultProps = {
	primaryKey: 'report_id',
	pageName: 'creditreportsummary',
	apiPath: 'creditreportsummary/index',
	routeName: 'creditreportsummarylist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default CreditreportsummaryListPage;
